// import Head from 'next/head'
import React from 'react'
import { Box, Stack, Center, Button } from '@chakra-ui/react'
import { FiCoffee } from 'react-icons/fi'
import * as Sentry from '@sentry/browser'
import { useOrder } from '../../context/order'
import { Order } from '../../components/Order'

export default function Index() {
	const { orders, confirmOrder, completeOrder } = useOrder()

	const handleConfirmOrder = async (orderId: number): Promise<void> => {
		try {
			confirmOrder(orderId)
		} catch (error) {
			Sentry.captureException(error)
			console.log(error)
		}
	}

	const handleCompleteOrder = async (orderId: number): Promise<void> => {
		try {
			completeOrder(orderId)
		} catch (error) {
			Sentry.captureException(error)
			console.log(error)
		}
	}

	return orders.length > 0 ? (
		<Stack spacing={4} align="center">
			{orders.map((order, index) => (
				<Order key={index} order={order}>
					<Center>
						{order.status === 'ordered' ? (
							<Button colorScheme="teal" onClick={() => handleConfirmOrder(order.id)} w="200px">
								確認
							</Button>
						) : order.status === 'confirmed' ? (
							<Button colorScheme="teal" onClick={() => handleCompleteOrder(order.id)} w="200px">
								ピックアップ完了
							</Button>
						) : (
							<></>
						)}
					</Center>
				</Order>
			))}
		</Stack>
	) : (
		<Box position="relative" height="100vh">
			<Box
				fontSize={24}
				position="absolute"
				top="50%"
				left="50%"
				transform="translateY(-50%) translateX(-50%)"
			>
				<Stack spacing={8}>
					<Box>新規注文はありません</Box>
					<Center>
						<FiCoffee size={48} />
					</Center>
				</Stack>
			</Box>
		</Box>
	)
}
